// Klantenservice-widget (snippets/support-widget.liquid).
//
// - Openen en sluiten: de knop, het kruisje, Escape of een tik buiten het
//   paneel. De focus gaat naar het paneel en daarna terug naar de knop.
// - Live status op Belgische tijd: "Nu open tot 18:00" of "Gesloten · opent
//   morgen om 13:00", uit dezelfde uren als de lijst in het paneel.
// - GTM: support_widget_open, support_widget_call en support_widget_mail.
// - Sommige pagina's hebben een balk onderaan: de bestelbalk en sticky footer
//   op de productpagina, de Filter-knop op de collectiepagina (mobiel). Die
//   komen en gaan, dus de knop meet telkens wat er onderaan in beeld staat en
//   schuift er precies boven (zie BARS).
(() => {
  const root = document.querySelector('.js-support-widget');

  if (!root || root.dataset.ready) {
    return;
  }

  root.dataset.ready = 'true';

  const toggle = root.querySelector('.js-support-widget-toggle');
  const panel = root.querySelector('.js-support-widget-panel');
  const close = root.querySelector('.js-support-widget-close');
  const status = root.querySelector('.js-support-widget-status');

  const track = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event });
  };

  // ---- Status -------------------------------------------------------------

  let schedule = {};
  try {
    schedule = JSON.parse(root.dataset.schedule || '{}');
  } catch (error) {
    schedule = {};
  }

  const dayNames = (root.dataset.days || '').split(',');

  const toMinutes = (time) => {
    const [hours, minutes] = time.split(':').map((part) => parseInt(part, 10));
    return hours * 60 + (minutes || 0);
  };

  // "13:00-18:00" -> [780, 1080]; leeg of onleesbaar = gesloten.
  const slot = (day) => {
    const value = schedule[day];
    if (!value || !/^\d{1,2}:\d{2}-\d{1,2}:\d{2}$/.test(value)) {
      return null;
    }
    const [from, to] = value.split('-');
    return { from, to, start: toMinutes(from), end: toMinutes(to) };
  };

  const brusselsNow = () => {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Brussels',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23',
    }).formatToParts(new Date());
    const get = (type) => parts.find((part) => part.type === type).value;
    const day = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(get('weekday')) + 1;
    return { day, minutes: parseInt(get('hour'), 10) * 60 + parseInt(get('minute'), 10) };
  };

  const fill = (template, values) =>
    template.replace('[time]', values.time || '').replace('[day]', values.day || '');

  const updateStatus = () => {
    if (!status) {
      return;
    }

    const now = brusselsNow();
    const today = slot(now.day);

    if (today && now.minutes >= today.start && now.minutes < today.end) {
      status.textContent = fill(root.dataset.openUntil, { time: today.to });
      status.classList.add('is-open');
      status.hidden = false;
      return;
    }

    status.classList.remove('is-open');

    // Eerstvolgende opening: vandaag nog (voor openingstijd), anders de
    // komende dagen.
    for (let offset = 0; offset < 7; offset += 1) {
      const day = ((now.day - 1 + offset) % 7) + 1;
      const next = slot(day);

      if (next && (offset > 0 || now.minutes < next.start)) {
        let template = root.dataset.opensOn;
        if (offset === 0) {
          template = root.dataset.opensToday;
        } else if (offset === 1) {
          template = root.dataset.opensTomorrow;
        }
        status.textContent = fill(template, { time: next.from, day: dayNames[day - 1] || '' });
        status.hidden = false;
        return;
      }
    }

    status.hidden = true;
  };

  // ---- Openen en sluiten ----------------------------------------------------

  const isOpen = () => !panel.hidden;

  const open = () => {
    updateStatus();
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    root.classList.add('is-open');
    panel.setAttribute('tabindex', '-1');
    panel.focus({ preventScroll: true });
    track('support_widget_open');
  };

  const shut = (returnFocus) => {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    root.classList.remove('is-open');
    if (returnFocus) {
      toggle.focus({ preventScroll: true });
    }
  };

  toggle.addEventListener('click', () => (isOpen() ? shut(true) : open()));

  if (close) {
    close.addEventListener('click', () => shut(true));
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen()) {
      shut(true);
    }
  });

  document.addEventListener('click', (event) => {
    if (isOpen() && !root.contains(event.target)) {
      shut(false);
    }
  });

  root.querySelectorAll('.js-support-widget-action').forEach((link) => {
    link.addEventListener('click', () => {
      track(link.dataset.action === 'call' ? 'support_widget_call' : 'support_widget_mail');
    });
  });

  // ---- Boven de balken onderaan blijven -------------------------------------

  const BARS = [
    '.js-sticky-footer', // productpagina: sticky footer (desktop)
    '.sticky-footer-content__right', // productpagina: bestelbalk (mobiel)
    '.filter-button-wrapper', // collectiepagina: Filter-knop (mobiel en tablet)
    '.b2b-lead__sticky', // B2B-pagina: vaste aanvraagknop
  ];

  const updateOffset = () => {
    let offset = 0;

    BARS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((bar) => {
        if (bar.hidden) {
          return;
        }
        const style = window.getComputedStyle(bar);
        if (style.position !== 'fixed' || style.display === 'none' || style.visibility === 'hidden') {
          return;
        }
        const rect = bar.getBoundingClientRect();
        // Alleen een balk die echt tegen de onderrand staat en in beeld is.
        if (rect.height > 0 && rect.top < window.innerHeight && Math.abs(window.innerHeight - rect.bottom) < 4) {
          offset = Math.max(offset, rect.height);
        }
      });
    });

    root.style.setProperty('--support-widget-offset', `${Math.round(offset)}px`);
  };

  let scheduled = false;
  const scheduleOffset = () => {
    if (scheduled) {
      return;
    }
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      updateOffset();
    });
  };

  window.addEventListener('resize', scheduleOffset);
  window.addEventListener('scroll', scheduleOffset, { passive: true });

  // De sticky footer krijgt de klasse "show" zodra hij inschuift.
  BARS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((bar) => {
      new MutationObserver(scheduleOffset).observe(bar, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
    });
  });

  updateOffset();
  updateStatus();
  setInterval(updateStatus, 60 * 1000);
})();
